<template>
    <div>
        <form-switch :sync="true" @change="toggle" :value="enabled"></form-switch>
        <span class="ml-1">Enabled</span>
    </div>
</template>

<script>
import formSwitch from '../generic/form-switch/form-switch.vue';

export default {
    components: { formSwitch },
    data() {
        return {
            enabled: null,
        };
    },
    methods: {
        async toggle() {
            this.enabled = !this.enabled;
            const response = await this.params.onToggleAll(this.enabled);
            if (!response) {
                this.enabled = !this.enabled;
            }
        },
    },
    mounted() {
        this.enabled = this.params.toggledAll;
    },
    watch: {
        ['params.toggledAll']() {
            this.enabled = this.params.toggledAll;
        },
    },
}
</script>